import { setContext } from '@apollo/client/link/context';
import { getAuthHeaders } from './auth.utils';

export const AuthHeadersApolloLink = setContext(async (req, { headers }) => {
  headers = await getAuthHeaders(headers);
  return {
    headers,
  };
});
